import { AbstractControl } from '@angular/forms';

export function NIPValidator(control: AbstractControl) {
  let nip = control.value;

  // tslint:disable
  if (nip === null || nip === undefined || nip.length === 0) {
    // if nip is not present, dont send error, use Validators.required
    return null;
  }
  nip = control.value.replace(/\-/g, '');
  if (nip.length === 10) { // sprawdzamy czy ciąg ma 10 cyfr
    // tslint:enable
    // Check digits
    for (let i = 0; i < 10; i++) {
      if (isNaN(nip[i])) {
        return { validNip: true };
      }
    }
    // Check checkdigit
    let sum = 6 * nip[0] +
      5 * nip[1] +
      7 * nip[2] +
      2 * nip[3] +
      3 * nip[4] +
      4 * nip[5] +
      5 * nip[6] +
      6 * nip[7] +
      7 * nip[8];
    sum %= 11;
    // tslint:disable
    if (sum === 10) {
      return { validNip: true };
    }

    if (nip[9] == sum) {
      // tslint:enable
      return null;
    }

  }
  return { validNip: true };
}
